import { useQuery } from "react-query";
import axios from "axios";
import { minutesAsMilliSeconds } from "../Utils/time";
import { namedQueryKey, QueryKeyName } from "../ReactQuery/namedQueryKeyWithId";
import { ExtractAllowed } from "../Utils/utilityTypes";

type OverviewLastUpdatedQueryKeyName = ExtractAllowed<QueryKeyName, "pdsrs" | "spdrs">;

export const overviewLastUpdatedQueryKey = (queryKey: OverviewLastUpdatedQueryKeyName) => [
  ...namedQueryKey(queryKey),
  "overviewLastUpdated",
];

export const useOverviewLastUpdated = (url: string, queryKey: OverviewLastUpdatedQueryKeyName) => {
  return useQuery({
    queryKey: overviewLastUpdatedQueryKey(queryKey),
    retry: 1,
    staleTime: minutesAsMilliSeconds(5),
    cacheTime: minutesAsMilliSeconds(10),
    queryFn: () => overviewLastUpdated(url),
  });
};

const overviewLastUpdated = async (url: string) => {
  const { data: lastUpdated } = await axios.get<string>(url);
  return lastUpdated;
};
